import { render, staticRenderFns } from "./StockByArticle.vue?vue&type=template&id=07db81b3&"
import script from "./StockByArticle.vue?vue&type=script&lang=js&"
export * from "./StockByArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports